<a
    class="btn btn-circle btn-primary element-chat-bot fixed bottom-6 right-6 z-50 !h-16 !w-16 !text-4xl btn-lg"
    [href]="chatbotUrl"
    target="_blank"
    rel="noopener noreferrer"
    [attr.aria-label]="'components.chatbot-bubble.aria-label' | translate"
    [siTooltip]="'components.chatbot-bubble.tooltip' | translate"
></a>
